import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import FormLayout from '../../../components/DesignSystem/Layout/FormLayout/FormLayout';
import advisorAdvantages from '../../../components/Identity/advisorAdvantages';
import {CreateAdvisorAccount} from '../../../data/apis/Identity';
import CreateAdvisorAccountForm from '../../../components/Identity/CreateAdvisorAccountForm/CreateAdvisorAccountForm';
import AccountancyFirmsLogos from '../../../components/Partners/PartnerLogos/AccountancyFirmsLogos';
import Headers, {HeaderType} from '../../../components/DesignSystem/Text/Headers/Headers';
import {Alignment} from '../../../types';

interface AllowedValues extends Omit<CreateAdvisorAccount, 'password' | 'marketingOptIn'> {}

interface Props {
  location?: {
    state?: AllowedValues;
  };
}

function AdvisorCreatePage({location}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const advantages = advisorAdvantages(formatMessage);

  const locationState = location?.state || ({} as AllowedValues);
  const {firstName, emailAddress, surname, companyNumber, companyName, partnerType} = locationState;

  return (
    <FormLayout advantages={advantages} sideBarBottomComponent={<AccountancyFirmsLogos />}>
      <div className="row">
        <div className="col-xs-12">
          <Headers headerType={HeaderType.H2} alignment={Alignment.LEFT}>
            <FormattedMessage id="phoenix.createAdvisorAccount.title" />
          </Headers>
          <CreateAdvisorAccountForm
            companyName={companyName}
            companyNumber={companyNumber}
            emailAddress={emailAddress}
            firstName={firstName}
            partnerType={partnerType}
            surname={surname}
          />
        </div>
      </div>
    </FormLayout>
  );
}

export default AdvisorCreatePage;
